import { render, staticRenderFns } from "./MdtDiseaseDetail.vue?vue&type=template&id=eba57802&scoped=true"
import script from "./MdtDiseaseDetail.vue?vue&type=script&lang=js"
export * from "./MdtDiseaseDetail.vue?vue&type=script&lang=js"
import style0 from "./MdtDiseaseDetail.vue?vue&type=style&index=0&id=eba57802&prod&lang=scss"
import style1 from "./MdtDiseaseDetail.vue?vue&type=style&index=1&id=eba57802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba57802",
  null
  
)

export default component.exports